import React from 'react';
import { Alert, Button, Card, Modal, Result, Space, Typography } from 'antd';
import { PRIMARY_COLOR } from '../upload.constants';
import { useAppSelector } from 'app/config/store';
import { SmileOutlined } from '@ant-design/icons';
import { cleanMessage } from '../utils';

const { Text, Title } = Typography;

interface ValidationSummaryProps {
  selectedOperation: any;
  selectedFile: any;
  parsedData: any[];
  errors: any[];
  isConfirmModalVisible: boolean;
  setIsConfirmModalVisible: (visible: boolean) => void;
  handleConfirm: () => void;
}

const ValidationSummary: React.FC<ValidationSummaryProps> = ({
  selectedOperation,
  parsedData,
  errors,
  isConfirmModalVisible,
  setIsConfirmModalVisible,
  handleConfirm,
  selectedFile,
}) => {
  const { loading: isLoading, successMessage, errorMessage } = useAppSelector(state => state.uploads);
  return (
    <div style={{ maxWidth: 800, margin: '0 auto' }}>
      <Title level={4}>Résumé de l&apos;opération</Title>
      <Card style={{ marginTop: 20, borderColor: PRIMARY_COLOR }}>
        <Space direction="vertical" style={{ width: '100%' }}>
          <Text strong>Opération: {selectedOperation?.label}</Text>
          <Text>Nombre d&apos;élèves: {parsedData.length}</Text>
          {errors.length > 0 && (
            <Alert
              message="Attention"
              description={`Il y a ${errors.length} erreur(s) dans les données. Voulez-vous continuer ?`}
              type="warning"
              showIcon
            />
          )}
          <Button
            type="primary"
            onClick={() => setIsConfirmModalVisible(true)}
            size="large"
            style={{ backgroundColor: PRIMARY_COLOR, borderColor: PRIMARY_COLOR }}
            disabled={!selectedFile}
          >
            Confirmer l&apos;opération
          </Button>
        </Space>
        {successMessage && <Result status={`success`} title="Opération réussie!" subTitle={cleanMessage(successMessage)} />}
        {errorMessage && <Result status={`error`} title="Opération échouée!" subTitle={errorMessage} />}
      </Card>

      <Modal
        title="Confirmer l'opération"
        visible={isConfirmModalVisible}
        onOk={handleConfirm}
        onCancel={() => setIsConfirmModalVisible(false)}
        okText="Confirmer"
        cancelText="Annuler"
        okButtonProps={{ disabled: isLoading, loading: isLoading }}
      >
        <Space direction="vertical">
          <Text>Vous êtes sur le point de :</Text>
          <Text strong>{selectedOperation?.label}</Text>
          <Text>Nombre d&apos;élèves concernés : {parsedData.length}</Text>
          {errors.length > 0 && (
            <Alert message="Attention" description={`Il y a ${errors.length} erreur(s) dans les données.`} type="warning" showIcon />
          )}
          <Text type="secondary">Cette action ne peut pas être annulée.</Text>
        </Space>
      </Modal>
    </div>
  );
};

export default ValidationSummary;
